import {observable} from 'mobx';
import {EarningsFormatter} from 'shared/tools';

class CommissionFormState {
  @observable model;
  @observable errors = {};
  @observable earningsFormatter;

  receiveProps({model, errors}) {
    this.model = model;
    this.errors = errors || {};
    this.earningsFormatter = new EarningsFormatter(model);
  }
}

export default CommissionFormState;
